module.exports = __webpack_public_path__ + "img/ca691b88259de761b8f16b3da0b9ccbc.png";